import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { TeamDataQuery, TeamDataQueryVariables } from './api.graphql';
import { TeamData } from './api.graphql';

export type TeamPageData = { staff: NonNullable<TeamDataQuery['staff']> };
export type TeamMember = TeamPageData['staff'][0];

export async function getTeamPageData({ gql: { fetch } }: UtilityContext): Promise<TeamPageData> {
	const { data } = await fetch<TeamDataQuery, TeamDataQueryVariables>({
		query: TeamData,
		rejectOnError: true,
	});

	return data;
}
